import React from 'react';
import {backNofill} from '../../../../assets/images/images';

export const GoBack = ({goBack}) => (
  <div onClick={goBack} className="flex items-center cursor-pointer  ">
    <img src={backNofill} width={20} alt="" />
    <p className="text-sm text-grey80 font-medium ">Back</p>
  </div>
);
